import { Breadcrumbs, Typography } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'


export const BreadCrumbsBuscarCliente = () => {
  return (
    <div className='my-3'>
        <Breadcrumbs aria-label="breadcrumb">
            <Link color="inherit" to="/buscar_cliente_redencion">
              Buscar Cliente
            </Link>
            
            <Typography color="text.primary">Redencion de bono</Typography>
        </Breadcrumbs>
    </div>
  )
}
